import { createValidator, rules } from "@lchemy/model/validation";

import { Application } from "../application";
import { User } from "../user";
import { AccessGroup } from "./access-group";

export interface AccessRole {
  id?: number;
  name: string;
  description?: string;
  isCustom: boolean;

  parent?: AccessRole;
  children?: AccessRole[];

  groups?: AccessGroup[];
  applications?: Application[];
  users?: User[];

  createdAt: string;
}

export const accessRoleValidator = createValidator<AccessRole>({
  name: [rules.required(), rules.isString(), rules.minLength(1)],
  description: [rules.isString()],
  isCustom: [rules.required(), rules.isBoolean()],
  children: [
    rules.required(),
    rules.each([
      rules.required(),
      rules.model<AccessRole>({
        id: [rules.required(), rules.isInt()]
      })
    ]),
    (children, role) => {
      if (!role.isCustom) {
        return children.length > 0 ? { noChildren: true } : null;
      }
      return null;
    }
  ],
  groups: [
    rules.required(),
    rules.each([
      rules.required(),
      rules.model<AccessGroup>({
        id: [rules.required(), rules.isInt()]
      })
    ])
  ],
  applications: [
    rules.required(),
    rules.each([
      rules.required(),
      rules.model<Application>({
        id: [rules.required(), rules.isInt()],
        features: [
          rules.each([
            rules.required()
          ])
        ]
      })
    ])
  ]
});
